import { render } from "./SettingsAccount.vue?vue&type=template&id=a8b45a36"
import script from "./SettingsAccount.vue?vue&type=script&lang=js"
export * from "./SettingsAccount.vue?vue&type=script&lang=js"
script.render = render

export default script